const policyContent = document.querySelector('[data-policy-content]');
const policyNavigation = document.querySelector('[data-policy-navigation]');

if (policyContent instanceof HTMLElement && policyNavigation instanceof HTMLOListElement) {
  const headings = policyContent.querySelectorAll('.shopify-policy__body h2');

  headings.forEach((heading, index) => {
    if (!(heading instanceof HTMLHeadingElement)) return;

    const id = `politica-${index + 1}`;
    const item = document.createElement('li');
    const link = document.createElement('a');

    heading.id = id;
    link.href = `#${id}`;
    link.dataset.index = String(index + 1).padStart(2, '0');
    link.textContent = heading.textContent?.trim() || `Seção ${index + 1}`;

    item.appendChild(link);
    policyNavigation.appendChild(item);
  });

  if (headings.length === 0) {
    policyNavigation.closest('nav')?.remove();
  }
}
